export const MAP_URLS={
    base: "https://xdworld.vworld.kr/2d/Base/service/{z}/{x}/{y}.png",
    hybrid: "https://xdworld.vworld.kr/2d/Hybrid/service/{z}/{x}/{y}.png",
    satellite: "https://xdworld.vworld.kr/2d/Satellite/service/{z}/{x}/{y}.jpeg"
}